<template>
  <div>
    <v-menu
      bottom
      left
      min-width="100"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          x-small
          icon
          outlined
          color="primary"
          v-bind="attrs"
          v-on="on"
        >
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>
      </template>
  
      <v-list
        dense
        class="pa-0"
      >
        <v-list-item
          :disabled="
            account.active
          "
          @click="verify()"
        >
          <v-list-item-title>
            <v-icon
              small
              left
              color="success"
            >
              mdi-shield-check
            </v-icon>
            Verify
          </v-list-item-title>
        </v-list-item>
        <v-list-item
          @click="enableEditAccount()"
        >
          <v-list-item-title>
            <v-icon
              small
              left
              color="success"
            >
              mdi-circle-edit-outline
            </v-icon>
            Edit
          </v-list-item-title>
        </v-list-item>
        <v-divider />
        <v-list-item
          v-if="account.activeStatus"
          @click="inActivate()"
        >
          <v-list-item-title>
            <v-icon
              small
              left
              color="error"
            >
              mdi-lightbulb-off
            </v-icon>
            In-activate
          </v-list-item-title>
        </v-list-item>
        <v-list-item
          v-else
          @click="activate()"
        >
          <v-list-item-title>
            <v-icon
              small
              left
              color="success"
            >
              mdi-lightbulb-on
            </v-icon>
            Activate
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <edit-account
      :show-dialog.sync="editAccount"
      :account-id="account.id"
      @refresh="$emit('reload');"
    />
  </div>
</template>
  
  <script>
  import { failure } from "@/mixins/common";
  import EditAccount from "./EditAccount";
  
  export default {
    name: "AccountOptions",
    components: {
        EditAccount
    },
    mixins: [failure],
    props: {
      account: {
        type: Object,
        required: true
      }
      // active: {
      //   type: Boolean,
      //   required: true 
      // }
    },
    data() {
      return {
        editAccount: false
      };
    },
    methods: {
      inActivate() {
        this.$root.$confirm
          .open("Confirm", "Are you sure you want to inactivate?", {})
          .then((confirm) => {
            if (!confirm) {
              return;
            }
            this.$http
              .put(
                `${this.EVM_API_URL}/accounts/${this.account.id}/inactivate`
              )
              .then(
                (data) => {
                  this.handleSuccess(data.body);
                },
                (failure) => {
                  this.handleFailure(failure);
                }
              );
          });
      },
      activate() {
        this.$root.$confirm
          .open("Confirm", "Are you sure you want to activate?", {})
          .then((confirm) => {
            if (!confirm) {
              return;
            }
            this.$http
              .put(
                `${this.EVM_API_URL}/accounts/${this.account.id}/activate`
              )
              .then(
                (data) => {
                  this.handleSuccess(data.body);
                },
                (failure) => {
                  this.handleFailure(failure);
                }
              );
          });
      },
      verify() {
      this.$http
        .put(`${this.EVM_API_URL}/accounts/${this.account.id}/verify`)
        .then(
          (data) => {
            this.handleSuccess(data.body);
          },
          (failure) => {
            this.handleFailure(failure);
          }
        );
    },
      handleSuccess(response) {
        this.$store.commit("showSnackbar", {
          timeout: 3000,
          message: response.message
        });
        this.$emit("reload");
      },
      enableEditAccount() {
      this.editAccount = true;
    }
    }
  };
  </script>s
  